<template>
  <div class="wrapper">
    <div class="shared__title">
      <h2 class="h2-custom" v-html="content.title"></h2>
      <p v-html="content.subtitle" class="text--big"></p>
    </div>
    <div class="list">
      <div
        class="list__item"
        v-for="(items, index) in content.items"
        :key="items"
      >
        <div class="list__text">
          <h3 v-html="items.title"></h3>
          <div v-html="items.text"></div>
        </div>
        <DraggableImages active-after="xl">
          <Picture
            :content="items"
            :style="`transform: rotate(${deg(
              index % 2 !== 1
            )}) translateY(-50%)`"
            :is-polaroid="true"
            data-draggable
            class="list__item__image"
          ></Picture>
        </DraggableImages>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { gsap } from 'gsap'
import { PropType } from 'vue'

// import { createSplitTitle, SplitTitle } from '@/animations/splitTitle'
import { Picture as PictureType } from '@/types'
import Picture from '@/components/global/Picture.vue'
import DraggableImages from '@/components/global/DraggableImages.vue'

import isMobile from 'ismobilejs'

// import Picture from '@/components/global/Picture.vue'
// import DraggableImages from '@/components/global/DraggableImages.vue'

// import isMobile from 'ismobilejs'

interface Shared {
  title: string
  subtitle: string
  items: {
    title: string
    text: string
    pictures: PictureType[]
  }
}

const deg = (negative: boolean) => {
  const deg = negative
    ? gsap.utils.random(-2, -20, 1)
    : gsap.utils.random(2, 20, 1)

  return `${deg}deg`
}

defineProps({
  content: {
    type: Object as PropType<Shared>,
    required: true,
  },
})
</script>

<style lang="scss" scoped>
:deep .picture-outer {
  top: 50%;
  width: 65rem !important;
  max-width: 65rem !important;
}
.wrapper {
  border-top: 1px solid var(--c-foreground);
  @include fluid(
    padding-top,
    (
      xxs: 40px,
      xxl: 130px,
    )
  );
}
.shared__title {
  h2 {
    @include mq($until: l) {
      @include fluid(
        margin-bottom,
        (
          xxs: 24px,
          xxl: 40px,
        )
      );
    }
  }
  @include mq(m) {
    display: flex;
    justify-content: space-between;
  }
}
@include mq(m) {
  h2 {
    width: col(5);
  }
}

.list__item {
  display: flex;
  justify-content: space-between;
  // prettier-ignore
  position: relative;

  @include fluid(
    margin-bottom,
    (
      xxs: 40px,
      xxl: 200px,
    )
  );
  @include fluid(
    margin-top,
    (
      xxs: 40px,
      xxl: 80px,
    )
  );

  .picture-outer {
    @include mq(nav) {
      width: 50rem !important;
      max-width: 50rem !important;
    }
    @include mq(xl) {
      width: 65rem !important;
      max-width: 65rem !important;
    }
  }

  &:nth-child(odd) {
    flex-direction: row-reverse;
    .picture-outer {
      @include mq(nav) {
        left: -135px;
      }
      @include mq(xl) {
        left: -100px;
      }
    }
  }
  &:nth-child(even) {
    flex-direction: row;
    .picture-outer {
      @include mq(nav) {
        right: -135px;
      }
      @include mq(xl) {
        right: -100px;
      }
    }
  }
  @include mq($until: nav) {
    flex-direction: column !important;
    .picture-outer {
      @include fluid(
        margin-top,
        (
          xxs: 40px,
          xxl: 80px,
        )
      );

      display: block;
      position: relative !important;
      width: 100%;
      height: auto;
      transform: none !important;
      left: inherit !important;
      right: inherit !important;
      width: 100% !important;
    }
  }
}
.list__text {
  @include mq(nav) {
    width: col(6);
  }
  @include mq(xl) {
    width: col(5);
    padding-right: col(0.5);
  }
  :deep h3 {
    margin-bottom: 24px;
  }
  :deep p {
    font-size: 16px;
    &:not(:last-child) {
      margin-bottom: 20px;
    }
  }
}
</style>
